module.exports = __webpack_public_path__ + "static/img/eicad_item2.770f3490.png";